// extracted by mini-css-extract-plugin
export var col = "vig-module--col--a6a9b";
export var item = "vig-module--item--c0a36";
export var vig = "vig-module--vig--519a1";